import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { VehicleModelEntity } from "./vehicle-model-entity";
import { VehicleModelController } from "./vehicle-model-controller";
import { VehicleModelService } from "./vehicle-model-service";
import { VehicleCategoryEntity } from "../vehicle-category/vehicle-category.entity";

@Module({
    imports: [
        TypeOrmModule.forFeature([VehicleModelEntity, VehicleCategoryEntity]),
    ],
    controllers: [VehicleModelController],
    providers: [VehicleModelService, ApplicationExceptionHandler]
})
export class VehicleModelModule {

}